import { DateHelpers } from "../helpers/date-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IChartDataService } from "../models/base/chart-data-service.interface";
import { ChartRequirementModel } from "../models/chart-requirement/chart-requirement.model";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { CompanyLogoDataModel } from "../models/company-logo/company-logo-data.model";
import { RealtimeTradeDataModel } from "../models/data-point/realtime-trade-data.model";
import { TIChartPointModel } from "../models/data-point/ti-chart-point.model";
import { TIComparisonDataModel } from "../models/data-point/ti-comparison-data.model";
import { TIComparisonHistoryDataModel } from "../models/data-point/ti-comparison-history-data.model";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { DrawOrderExecutionModel } from "../models/draw-trade-order/draw-order-execution.model";
import { DrawTradePriceAnnotationModel } from "../models/draw-trade-order/draw-trade-price-annotation.model";
import { TradeOrderDataModel } from "../models/draw-trade-order/trade-order-data.model";
import { EmojiModel } from "../models/drawing-tools/emoji.model";
import { DrawEarningNotificationDataModel } from "../models/earning/draw-earning-notification-data.model";
import { ChartType } from "../models/enum/chart-type.enum";
import { Timeframe } from "../models/enum/timeframe.enum";
import { HeartStatusDataModel } from "../models/heart-status/heart-status-data.model";
import { LimitAlertImageModel } from "../models/limit-alert/limit-alert-image.model";
import { LimitAlertModel } from "../models/limit-alert/limit-alert.model";
import { CurrentPositionDataModel } from "../models/pnl/current-position-data.model";
import { PnlDataModel } from "../models/pnl/pnl-data.model";
import { SmartStopLinesModel } from "../models/smart-risk-level/smart-stop-lines.model";
import { SwingExitModel } from "../models/smart-risk-level/swing-exit.model";
declare const window: any;
declare const winformObj: any;

export class WindowFormChartDataService implements IChartDataService {

    private subscribeChartRequestingNewSymbolDataCallbacks: Array<Function> = [];
    private subscribeInitChartDataCallbacks: Array<Function> = [];
    private subscribeInitChartIndicatorsDataCallbacks: Array<Function> = [];
    private subscribeInitChartComparisonsDataCallbacks: Array<Function> = [];
    private subscribeInitChartDrawingToolsCallbacks: Array<Function> = [];
    private subscribeUpdate10sRefreshChartDataCallbacks: Array<Function> = [];
    private subscribeUpdate10sRefreshIndicatorsDataCallbacks: Array<Function> = [];
    private subscribeUpdateChartHistoryDataCallbacks: Array<Function> = [];
    private subscribeUpdateHistoryIndicatorsDataCallbacks: Array<Function> = [];
    private subscribeUpdateChartHistoryComparisonDataCallbacks: Array<Function> = [];
    private subscribeRealtimeDataCallbacks: Array<Function> = [];
    private subscribeChartStyleDataCallbacks: Array<Function> = [];
    private subscribePnlDataCallbacks: Array<Function> = [];
    private subscribeCurrentPositionDataCallbacks: Array<Function> = [];
    private subscribeTICompanyLogoDataCallbacks: Array<Function> = [];
    private subscribeChartRequirementsDataCallbacks: Array<Function> = [];
    private subscribeChartAllowBuyDataCallbacks: Array<Function> = [];
    private subscribeChartAllowSellDataCallbacks: Array<Function> = [];
    private subscribeCompanyLogoDataCallbacks: Array<Function> = [];
    private subscribeDrawTradeOrdersDataCallbacks: Array<Function> = [];
    private subscribeDrawOrderExecutionDataCallbacks: Array<Function> = [];
    private subscribePriceAlertsDataCallbacks: Array<Function> = [];
    private subscribePriceAlertsImageDataCallbacks: Array<Function> = [];
    private subscribeEarningNotificationDataCallbacks: Array<Function> = [];
    private subscribeHaltedNotificationDataCallbacks: Array<Function> = [];
    private subscribeSwingExitDataCallbacks: Array<Function> = [];
    private subscribSmartRiskDataCallbacks: Array<Function> = [];
    private subscribHeartStatusDataCallbacks: Array<Function> = [];
    private subscribeDrawEarningNotificationDataCallbacks: Array<Function> = [];
    private subscribeLastPriceDataCallbacks: Array<Function> = [];
    private subscribeDrawTradePriceAnnotationsCallbacks: Array<Function> = [];
    private subscribeWindowMinimizeUpdateCallbacks: Array<Function> = [];
    private subscribeEmojiDataCallbacks: Array<Function> = [];

    private symbol = '';

    private baseChart: IChartContainer;
    constructor(baseChart: IChartContainer) {
        this.baseChart = baseChart;
        this.onSubscribeChartRequestingNewSymbolData();
        this.onSubscribeInitChartData();
        this.onSubscribeInitChartIndicatorsData();
        this.onSubscribeInitChartComparisonsData();
        this.onSubscribeInitChartDrawingTools();
        this.onSubscribeUpdate10sRefreshChartData();
        this.onSubscribeUpdate10sRefreshIndicatorsData();
        this.onSubscribeUpdate10sRefreshIndicatorsData();
        this.onSubscribeUpdateChartHistoryData();
        this.onSubscribeUpdateHistoryIndicatorsData();
        this.onSubscribeUpdateChartHistoryComparisonData();
        this.onSubscribeRealtimeData();
        this.onSubscribeChartStyleData();
        this.onSubscribePnlData();
        this.onSubscribeCurrentPositionData();
        this.onSubscribeTICompanyLogoData();
        this.onSubscribeChartRequirementsData();
        this.onSubscribeAllowBuyData();
        this.onSubscribeAllowSellData();
        this.onSubscribeCompanyLogoData();
        this.onSubscribeDrawTradeOrdersData();
        this.onSubscribeDrawOrderExecutionData();
        this.onSubscribePriceAlertsData();
        this.onSubscribePriceAlertsImageData();
        this.onSubscribeEarningNotificationData();
        this.onSubscribeHaltedNotificationData();
        this.onSubscribeSwingExitData();
        this.onSubscribeSmartRiskData();
        this.onSubscribeHeartStatusData();
        this.onSubscribeDrawEarningNotificationData();
        this.onSubscribeLastPriceData();
        this.onSubscribeDrawTradePriceAnnotations();
        this.onSubscribeWindowMinimizeUpdate();
        this.onSubscribeEmojiData();
    }

    public getSymbolLabel(): string {
        return this.symbol;
    }
    
    public subscribeChartRequestingNewSymbolData(callback: Function) {
        this.subscribeChartRequestingNewSymbolDataCallbacks.push(callback);
    }

    private onSubscribeChartRequestingNewSymbolData() {
        window.onChartRequestingNewSymbol = (symbol: string, timeframe: Timeframe) => {
            if (this.symbol != symbol) {
                this.symbol = symbol;            
            }
            for (const callback of this.subscribeChartRequestingNewSymbolDataCallbacks) {
                callback(symbol, timeframe);
            }
        };
    }

    public subscribeInitChartData(callback: Function) {
        this.subscribeInitChartDataCallbacks.push(callback);
    }

    private onSubscribeInitChartData() {
        window.initChartData = (data: Array<TIChartPointModel>, timeframe: Timeframe, symbol: string, chartType: ChartType) => {
            
            this.symbol = symbol;
            
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }

            console.log('subscribeInitChartData: ', model, timeframe, symbol, chartType);
            for (const callback of this.subscribeInitChartDataCallbacks) {
                callback(model, timeframe, symbol, chartType);
            }
        };
    }

    public subscribeInitChartIndicatorsData(callback: Function) {
        this.subscribeInitChartIndicatorsDataCallbacks.push(callback);
    }

    private onSubscribeInitChartIndicatorsData() {
        window.initChartIndicatorsData = (data: Array<TIIndicatorDataModel>) => {
            const model: Array<TIIndicatorDataModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIIndicatorDataModel(data[i]));
                }
            }
            console.log('subscribeInitChartIndicatorsData :', model);
            for (const callback of this.subscribeInitChartIndicatorsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeInitChartComparisonsData(callback: Function) {
        this.subscribeInitChartComparisonsDataCallbacks.push(callback);
    }

    private onSubscribeInitChartComparisonsData() {
        window.initChartComparisonsData = (data: Array<TIComparisonDataModel>) => {
            console.log('subscribeInitChartComparisonsData :', data);

            const model: Array<TIComparisonDataModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIComparisonDataModel(data[i]));
                }
            }

            for (const callback of this.subscribeInitChartComparisonsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeInitChartDrawingTools(callback: Function) {
        this.subscribeInitChartDrawingToolsCallbacks.push(callback);
    }

    private onSubscribeInitChartDrawingTools() {
        window.initChartDrawingTools = (symbol: string, timeframe: Timeframe, drawingToolData: any) => {
            let model: any = [];

            if (drawingToolData && drawingToolData.data) {
                try {
                    model = JSON.parse(drawingToolData.data);
                } catch { }
            }

            for (const callback of this.subscribeInitChartDrawingToolsCallbacks) {
                callback(symbol, timeframe, model);
            }
        };
    }

    public subscribeUpdate10sRefreshChartData(callback: Function) {
        this.subscribeUpdate10sRefreshChartDataCallbacks.push(callback);
    }

    private onSubscribeUpdate10sRefreshChartData() {
        window.update10sRefreshChartData = (data: Array<TIChartPointModel>) => {
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }
            // console.log('update10sRefreshChartData: ', model);
            for (const callback of this.subscribeUpdate10sRefreshChartDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeUpdate10sRefreshIndicatorsData(callback: Function) {
        this.subscribeUpdate10sRefreshIndicatorsDataCallbacks.push(callback);
    }

    private onSubscribeUpdate10sRefreshIndicatorsData() {
        window.update10sRefreshIndicatorsData = (data: Array<TIIndicatorDataModel>) => {
            const model: Array<TIIndicatorDataModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIIndicatorDataModel(data[i]));
                }
            }
            // console.log('update10sRefreshIndicatorsData :', model);
            for (const callback of this.subscribeUpdate10sRefreshIndicatorsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeUpdateChartHistoryData(callback: Function) {
        this.subscribeUpdateChartHistoryDataCallbacks.push(callback)
    }

    private onSubscribeUpdateChartHistoryData() {
        window.updateChartHistoryData = (data: Array<TIChartPointModel>) => {
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }
            console.log('updateChartHistoryData: ', model);
            for (const callback of this.subscribeUpdateChartHistoryDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeUpdateHistoryIndicatorsData(callback: Function) {
        this.subscribeUpdateHistoryIndicatorsDataCallbacks.push(callback);
    }

    private onSubscribeUpdateHistoryIndicatorsData() {
        window.updateHistoryIndicatorsData = (data: Array<TIIndicatorDataModel>) => {
            const model: Array<TIIndicatorDataModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIIndicatorDataModel(data[i]));
                }
            }
            console.log('updateHistoryIndicatorsData :', model);
            for (const callback of this.subscribeUpdateHistoryIndicatorsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeUpdateChartHistoryComparisonData(callback: Function) {
        this.subscribeUpdateChartHistoryComparisonDataCallbacks.push(callback);
    }

    private onSubscribeUpdateChartHistoryComparisonData() {
        window.updateChartComparisonHistoryData = (data: TIComparisonHistoryDataModel) => {
            const model = new TIComparisonHistoryDataModel(data);
            console.log('updateChartHistoryComparisonData :', model);
            for (const callback of this.subscribeUpdateChartHistoryComparisonDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeRealtimeData(callback: Function) {
        this.subscribeRealtimeDataCallbacks.push(callback);
    }

    private onSubscribeRealtimeData() {
        window.updateRealtimeData = (data: RealtimeTradeDataModel) => {
            const model = new RealtimeTradeDataModel(data);
            // console.log('subscribeRealtimeData :', model);
            for (const callback of this.subscribeRealtimeDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeChartStyleData(callback: Function) {
        this.subscribeChartStyleDataCallbacks.push(callback);
    }

    private onSubscribeChartStyleData() {
        window.updateChartStyleData = (data: ChartStyleSettingsModel) => {
            const model = new ChartStyleSettingsModel(data);
            // console.log('subscribeChartStyleData :', model);
            for (const callback of this.subscribeChartStyleDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribePnlData(callback: Function) {
        this.subscribePnlDataCallbacks.push(callback);
    }

    private onSubscribePnlData() {
        window.updatePnlData = (data: PnlDataModel) => {
            const model = new PnlDataModel(data);
            // console.log('subscribePnlData :', model);
            for (const callback of this.subscribePnlDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeCompanyLogoData(callback: Function) {
        this.subscribeCompanyLogoDataCallbacks.push(callback);
    }

    private onSubscribeCompanyLogoData() {
        window.updateCompanyLogoData = (data: CompanyLogoDataModel) => {
            const model = new CompanyLogoDataModel(data);
            // console.log('subscribeCompanyLogoData :', model);
            for (const callback of this.subscribeCompanyLogoDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeCurrentPositionData(callback: Function) {
        this.subscribeCurrentPositionDataCallbacks.push(callback);
    }

    private onSubscribeCurrentPositionData() {
        window.updateCurrentPositionData = (data: Array<CurrentPositionDataModel>) => {
            const model: Array<CurrentPositionDataModel> = [];
            if (data?.length) {
                for (const item of data) {
                    model.push(new CurrentPositionDataModel(item));
                }
            }

            // console.log('subscribeCurrentPositionData :', model);
            for (const callback of this.subscribeCurrentPositionDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeTICompanyLogoData(callback: Function) {
        this.subscribeTICompanyLogoDataCallbacks.push(callback);
    }

    private onSubscribeTICompanyLogoData() {
        window.updateTICompanyLogoData = (data: string) => {
            // console.log('subscribeTICompanyLogoData :', data);
            for (const callback of this.subscribeTICompanyLogoDataCallbacks) {
                callback('data:image/png;base64,' + data);
            }
        };
    }

    public subscribeChartRequirementsData(callback: Function) {
        // console.log('subscribeChartRequirementsData')
        this.subscribeChartRequirementsDataCallbacks.push(callback);
    }

    private onSubscribeChartRequirementsData() {
        window.updateChartRequirementsData = (data: ChartRequirementModel) => {
            // console.log('subscribeChartRequirementsData :', data);
            const model = new ChartRequirementModel(data);
            for (const callback of this.subscribeChartRequirementsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeChartAllowBuyData(callback: Function) {
        this.subscribeChartAllowBuyDataCallbacks.push(callback);
    }

    private onSubscribeAllowBuyData() {
        window.allowChartBuy = () => {
            for (const callback of this.subscribeChartAllowBuyDataCallbacks) {
                callback();
            }
        };
    }

    public subscribeChartAllowSellData(callback: Function) {
        this.subscribeChartAllowSellDataCallbacks.push(callback);
    }

    private onSubscribeAllowSellData() {
        window.allowChartSell = () => {
            for (const callback of this.subscribeChartAllowSellDataCallbacks) {
                callback();
            }
        };
    }

    public subscribeDrawTradeOrdersData(callback: Function) {
        this.subscribeDrawTradeOrdersDataCallbacks.push(callback);
    }

    private onSubscribeDrawTradeOrdersData() {
        window.updateDrawTradeOrdersData = (data: Array<TradeOrderDataModel>) => {
            const model: Array<TradeOrderDataModel> = [];

            if (data?.length) {
                for (const item of data) {
                    model.push(new TradeOrderDataModel(item));
                }
            }

            console.log('subscribeDrawTradeOrdersData :', model);
            for (const callback of this.subscribeDrawTradeOrdersDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeDrawOrderExecutionData(callback: Function) {
        this.subscribeDrawOrderExecutionDataCallbacks.push(callback);
    }

    private onSubscribeDrawOrderExecutionData() {
        window.updateDrawOrderExecutionData = (data: Array<DrawOrderExecutionModel>) => {
            const model: Array<DrawOrderExecutionModel> = [];

            if (data?.length) {
                for (const item of data) {
                    model.push(new DrawOrderExecutionModel(item));
                }
            }

            console.log('subscribeDrawOrderExecutionData :', model);
            for (const callback of this.subscribeDrawOrderExecutionDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribePriceAlertsData(callback: Function) {
        this.subscribePriceAlertsDataCallbacks.push(callback);
    }

    private onSubscribePriceAlertsData() {
        window.updateLimitAlertsData = (data: Array<LimitAlertModel>) => {
            const model: Array<LimitAlertModel> = [];

            if (data?.length) {
                for (const item of data) {
                    model.push(new LimitAlertModel(item));
                }
            }

            // console.log('subscribePriceAlertsData :', model);
            for (const callback of this.subscribePriceAlertsDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribePriceAlertsImageData(callback: Function) {
        this.subscribePriceAlertsImageDataCallbacks.push(callback);
    }

    private onSubscribePriceAlertsImageData() {
        window.updateLimitAlertImageData = (data: LimitAlertImageModel) => {
            const model = new LimitAlertImageModel(data);

            console.log('subscribePriceAlertsImageData :', model);
            for (const callback of this.subscribePriceAlertsImageDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeEarningNotificationData(callback: Function) {
        this.subscribeEarningNotificationDataCallbacks.push(callback);
    }

    private onSubscribeEarningNotificationData() {
        window.updateEarningNotification = (data: string) => {
            // console.log('subscribeEarningNotificationData :', data);
            for (const callback of this.subscribeEarningNotificationDataCallbacks) {
                callback(data);
            }
        };
    }

    public subscribeHaltedNotificationData(callback: Function) {
        this.subscribeHaltedNotificationDataCallbacks.push(callback);
    }

    private onSubscribeHaltedNotificationData() {
        window.updateHaltedNotification = (showNotification: boolean, description: string) => {
            // console.log('subscribeHaltedNotificationData :', showNotification, description);
            for (const callback of this.subscribeHaltedNotificationDataCallbacks) {
                callback(showNotification, description);
            }
        };
    }

    public subscribeLastPriceData(callback: Function) {
        this.subscribeLastPriceDataCallbacks.push(callback);
    }

    private onSubscribeLastPriceData() {
        window.updateLastPriceData = (price: number) => {
            // console.log('updateLastPriceData ', price)
            for (const callback of this.subscribeLastPriceDataCallbacks) {
                callback(price);
            }
        };
    }

    public subscribeDrawTradePriceAnnotations(callback: Function) {
        this.subscribeDrawTradePriceAnnotationsCallbacks.push(callback);
    }

    private onSubscribeDrawTradePriceAnnotations() {
        window.updateDrawTradePriceAnnotations = (data: Array<DrawTradePriceAnnotationModel>) => {
            const model: Array<DrawTradePriceAnnotationModel> = [];

            if (data?.length) {
                for (const item of data) {
                    model.push(new DrawTradePriceAnnotationModel(item));
                }
            }

            console.log('updateDrawTradePriceAnnotations ', model)
            for (const callback of this.subscribeDrawTradePriceAnnotationsCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeWindowMinimizeUpdate(callback: Function) {
        this.subscribeWindowMinimizeUpdateCallbacks.push(callback);
    }

    private onSubscribeWindowMinimizeUpdate() {
        window.windowMinimizeUpdate = (shouldRedraw: boolean) => {
            console.log('onSubscribeRedraw shouldRedraw: ', shouldRedraw)
            for (const callback of this.subscribeWindowMinimizeUpdateCallbacks) {
                callback(shouldRedraw);
            }
        };
    }

    public subscribeSwingExitData(callback: Function) {
        this.subscribeSwingExitDataCallbacks.push(callback);
    }

    private onSubscribeSwingExitData() {
        window.updateSwingExit = (data: SwingExitModel) => {
            const model = new SwingExitModel(data);
            // console.log('subscribeSwingExitData :', model);
            for (const callback of this.subscribeSwingExitDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeSmartRiskData(callback: Function) {
        this.subscribSmartRiskDataCallbacks.push(callback);
    }

    private onSubscribeSmartRiskData() {
        window.updateSmartStopLines = (data: SmartStopLinesModel) => {
            const model = new SmartStopLinesModel(data);
            // console.log('subscribeSmartRiskData :', model);
            for (const callback of this.subscribSmartRiskDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeHeartStatusData(callback: Function) {
        this.subscribHeartStatusDataCallbacks.push(callback);
    }

    private onSubscribeHeartStatusData() {
        window.updateHeartStatusData = (data: HeartStatusDataModel) => {
            const model = new HeartStatusDataModel(data);
            console.log('subscribeHeartStatusData :', model);
            for (const callback of this.subscribHeartStatusDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeDrawEarningNotificationData(callback: Function) {
        this.subscribeDrawEarningNotificationDataCallbacks.push(callback);
    }

    private onSubscribeDrawEarningNotificationData() {
        window.updateDrawEarningNotificationData = (data: DrawEarningNotificationDataModel) => {
            const model = new DrawEarningNotificationDataModel(data);
            if (this.baseChart.tiChartSeries?.tiChartPoints?.length) {
                for (const chartData of this.baseChart.tiChartSeries.tiChartPoints) {
                    const pointStartDateStr = DateHelpers.format('dd-mm-yyyy', chartData.start);
                    const pastEarningsDateStr = DateHelpers.format('dd-mm-yyyy', model.earningDate);

                    if (pointStartDateStr == pastEarningsDateStr) {
                        model.xValue = chartData.xValue;
                        break;
                    }
                }
            }

            // console.log('subscribeDrawEarningNotificationData :', model);
            for (const callback of this.subscribeDrawEarningNotificationDataCallbacks) {
                callback(model);
            }
        };
    }

    public subscribeEmojiData(callback: Function) {
        this.subscribeEmojiDataCallbacks.push(callback);
    }

    private onSubscribeEmojiData() {
        window.initEmojiData = (data: Array<EmojiModel>) => {
            const model = EmojiModel.makeList(data);
            // console.log('subscribeEmojiData :', model);
            for (const callback of this.subscribeEmojiDataCallbacks) {
                callback(model);
            }
        };
    }

    public notifyChartHideContextMenu() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.hideContextMenu();
    }

    public requestHistory() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestHistory();
    }

    public requestOpenSymbolLookup(symbol: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.openSymbolLookup(symbol);
    }

    public requestNewSymbol(symbol: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.switchSymbol(symbol);
    }

    public requestNewTimeframe(timeframe: Timeframe) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.switchTimeframe(timeframe);
    }

    public requestNewChartType(chartType: ChartType) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.switchChartType(chartType);
    }

    public requestBuy() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.selectBuy();
    }

    public requestSell() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.selectSell();
    }

    public requestInitiateChartTrade(price: number, isLong: boolean) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestInitiateChartTrade(price, isLong);
    }

    public requestUpdateChartTrade(orderId: string, price: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestUpdateChartTrade(orderId, price);
    }

    public requestUpdateLimitAlert(id: string, price: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestUpdateLimitAlert(id, price);
    }

    public requestRemoveChartTrade(orderId: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestRemoveChartTrade(orderId);
    }

    public requestRemoveLimitAlert(id: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestRemoveLimitAlert(id);
    }

    public requestUpdateLastPriceClicked(price: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestUpdateLastPriceClicked(price, false);
    }

    public requestAddIndicators() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestAddIndicators();
    }

    public requestAddPriceAlert() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestAddPriceAlert();
    }

    public requestAddAVWap(xValue: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestAddAVWap(xValue);
    }

    public requestAddComparisonSymbols() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestAddComparisonSymbols();
    }

    public requestOpenComparisonSymbolLookup(symbol: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestOpenComparisonSymbolLookup(symbol);
    }

    public requestSetHeartLikedStatus() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestSetHeartLikedStatus();
    }

    public requestCameraTakeScreenshot() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestCameraTakeScreenshot();
    }

    public requestSetZoomLevel(clientZoomLevel: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestSetZoomLevel(clientZoomLevel);
    }

    public requestSetPnPState(position: string, expanded: boolean, timeframe: Timeframe) {
        return;
    }

    public requestMouseEnter() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestMouseEnter();
    }

    public requestMouseLeave() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestMouseLeave();
    }

    public requestSaveDrawingTools(data: Array<any>) {
        if (!this.winformObjHasValue()) {
            return;
        }


        let dataStr = '';

        if (data?.length) {
            try {
                dataStr = JSON.stringify(data);
            } catch { }
        }

        console.log('requestSaveDrawingTools ', dataStr)
        winformObj.requestSaveDrawingTools(dataStr);
    }

    public chartReady() {
        if (!this.winformObjHasValue()) {
            return;
        }

        setTimeout(() => {
            console.log('called onChartReady');
            winformObj.onChartReady();
        }, 500);
    }

    private winformObjHasValue() {
        return typeof (winformObj) != 'undefined' && !!winformObj;
    }
}
